import { useEffect, useState } from "react";
import axios from "axios";
import { Authentication } from "../types/Authentication";

export enum AuthenticationStatus {
  Authenticated,
  Unauthenticated,
  Unknown,
}

const LOCAL_STORAGE_AUTH_KEY = "auth";

export const InitiateAuth = () => {
  const [token, setToken] = useState<string | null>(null);
  const [authenticationStatus, setAuthenticationStatus] = useState<AuthenticationStatus>(AuthenticationStatus.Unknown);

  useEffect(() => {
    async function getToken() {
      try {
        const auth = localStorage.getItem(LOCAL_STORAGE_AUTH_KEY);
        if (auth) {
          const authData = JSON.parse(auth) as Authentication;
          if (Math.floor(new Date().getTime() / 1000) < authData.expiry) {
            setAuthenticationStatus(AuthenticationStatus.Authenticated);
            setToken(authData.token);
            return;
          }
        }

        const password = prompt("Please authenticate to continue");
        if (!password) {
          return setAuthenticationStatus(AuthenticationStatus.Unauthenticated);
        }

        const response = await axios.post<Authentication>("https://api.saneetbhella.co.uk/finance/auth", {
          password,
        });

        setAuthenticationStatus(AuthenticationStatus.Authenticated);
        setToken(response.data.token);

        const newAuth = {
          token: response.data.token,
          expiry: Math.floor(new Date().getTime() / 1000) + response.data.expiry,
        };

        localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, JSON.stringify(newAuth));
      } catch (err: any) {
        setAuthenticationStatus(AuthenticationStatus.Unauthenticated);
        console.error(err);
      }
    }
    getToken();
  }, []);

  return { authenticationStatus, token };
};
